import BtnBase from "@components/Buttons/BtnBase";
import DatePickerController from "@components/FormControllers/controllers/DatePickerController";
import EmailInputController from "@components/FormControllers/controllers/EmailInputController";
import InputController from "@components/FormControllers/controllers/InputController";
import PasswordInputController from "@components/FormControllers/controllers/PasswordInputController";
import PhoneInputController from "@components/FormControllers/controllers/PhoneInputController";
import PasswordValidation from "@components/PasswordValidation";
import { Typography } from "@mui/material";
import useTranslation from "next-translate/useTranslation";
import { useSelector } from "noval";
import dayjs from "dayjs";
import CustomImage from "@components/CustomImage";
import CheckboxController from "@components/FormControllers/controllers/CheckboxController";
import { Text } from "@utils/helper";
import Trans from "next-translate/Trans";
import Link from "next/link";

const RegisterForm = ({
  watch,
  control,
  loading,
  handleSubmit,
  handleRegister,
}) => {
  const today = dayjs();
  const confirmed = watch("confirmed");
  const screen = useSelector("screen");
  const maxDate = today.subtract(18, "year");
  const minDate = today.subtract(120, "year");
  const { t, lang } = useTranslation("register");

  return (
    <form
      className="flex flex-col justify-start items-center gap-4 sm:gap-8 "
      onSubmit={handleSubmit(handleRegister)}
    >
      <PhoneInputController
        control={control}
        inputBg="#FFFFFF"
        name="phone"
        removeText
        phoneVal={
          <>
            <CustomImage
              width={24}
              height={24}
              className="w-6"
              src="/images/global/ksa.png"
              alt="ksa"
            />
            <Typography>966</Typography>
          </>
        }
        clsName="w-full"
        classNameLabel="leading-[21px] font-bold"
        customLabel={screen === "sm-phone" ? null : t("labels:phone")}
        inputConstrains={{ maxLength: 9 }}
        placeholder={t("placeholders:phone")}
        sx={{ boxShadow: "0px 8px 16px -25px #00000005" }}
        inputSize="16px"
      />
      <EmailInputController
        control={control}
        name="email"
        inputBg="#FFFFFF"
        clsName="w-full"
        customLabel={screen === "sm-phone" ? null : t("labels:email")}
        classNameLabel="leading-[21px] font-bold"
        placeholder={t("placeholders:email")}
        sx={{ boxShadow: "0px 8px 16px -25px #00000005" }}
        inputStyles={{
          "& .MuiInputBase-input": {
            direction: "ltr",
            textAlign: lang === "ar" ? "right" : "left",
          },
        }}
        inputSize="16px"
      />
      <InputController
        control={control}
        removeText
        inputBg="#FFFFFF"
        name="nin"
        clsName="w-full"
        customLabel={screen === "sm-phone" ? null : t("labels:national_id")}
        classNameLabel="leading-[21px] font-bold"
        inputConstrains={{ maxLength: 10 }}
        placeholder={t("placeholders:national_id")}
        sx={{ boxShadow: "0px 8px 16px -25px #00000005" }}
        inputSize="16px"
      />
      <DatePickerController
        minDate={minDate}
        maxDate={maxDate}
        control={control}
        inputBg="#FFFFFF"
        name="birth_date"
        clsName="w-full"
        customLabel={screen === "sm-phone" ? null : t("labels:date_of_birth")}
        classNameLabel="leading-[21px] font-bold"
        placeholder={t("placeholders:date_of_birth")}
        sx={{ boxShadow: "0px 8px 16px -25px #00000005" }}
      />
      <PasswordInputController
        control={control}
        name="password"
        clsName="w-full"
        customLabel={screen === "sm-phone" ? null : t("labels:password")}
        placeholder={t("placeholders:password")}
        fontFamily="math, sans-serif"
        classNameLabel="leading-[21px] font-bold"
        inputBg="#FFFFFF"
        sx={{ boxShadow: "0px 8px 16px -25px #00000005" }}
        inputSize="16px"
      />
      <div className="-mt-[14px] ml-3 flex flex-col w-full gap-2">
        <PasswordValidation control={control} />
      </div>

      <CheckboxController
        control={control}
        name="confirmed"
        className="w-full"
        label={
          <Text weight={400} top="9px">
            <Link
              className="underline text-[#0366FF]"
              href="/opening-agreement"
              target="_blank"
            >
              {t("accept")}
            </Link>
          </Text>
        }
      />
      <BtnBase
        type="submit"
        variant="contained"
        sx={{
          width: "100%",
          height: "45",
          borderRadius: "48px",
          fontSize: "16px",
          textTransform: "capitalize",
          boxShadow: "0px 8px 16px 0px #00000010 !important",
        }}
        isLoading={loading}
        disabled={!confirmed}
        className="items-center justify-center !font-Expo_sim !font-medium !text-[13px] sm:!text-[16px]"
      >
        {t("signUp")}
      </BtnBase>
    </form>
  );
};

export default RegisterForm;
